export default {
	methods: {
		openNotification(title, text, position = null, color = "#1A1A1A") {
			this.$vs.notification({
				color,
				position,
				title,
				text
			})
		}
	}
}
